var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_filled_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4H7V6C7 6.55228 7.44772 7 8 7C8.55228 7 9 6.55228 9 6V4H15V6C15 6.55228 15.4477 7 16 7C16.5523 7 17 6.55228 17 6V4H19C20.1046 4 21 4.89543 21 6V9H3V6C3 4.89543 3.89543 4 5 4ZM3 11V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V11H3Z",
    fill: "#99A2AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 36589",
    d: "M7 2C7 1.44772 7.44772 1 8 1C8.55228 1 9 1.44772 9 2V4H7V2Z",
    fill: "#99A2AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 36590",
    d: "M15 2C15 1.44772 15.4477 1 16 1C16.5523 1 17 1.44772 17 2V4H15V2Z",
    fill: "#99A2AD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachPlan);
export default __webpack_public_path__ + "static/media/attach_plan.3337262142a89f6803900a620bb4a9ca.svg";
export { ForwardRef as ReactComponent };